export const formEvent = 'form'
export const interactionFormEvent = 'interaction_form'
export const interactionQuestionEvent = 'interaction_question'
export const interactionQuestionMultipleChoiceEvent = 'interaction_question_multiple_choice'
export const answerEvent = 'answer'
export const metaEvent = 'meta'
export const buttonEvent = 'button'
